import React from "react";
import GitHubIcon from "@mui/icons-material/GitHub";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
// import InstagramIcon from "@mui/icons-material/Instagram";
import TwitterIcon from "@mui/icons-material/Twitter";

const Contact = () => {
  return (
    <div className="text-white w-11/12 lg:w-9/12">
      {/* <h1 className="text-center my-12 text-4xl text-white">Contact</h1> */}
      <div className="flex flex-wrap justify-between pb-8 pt-8">
        {/* <div className="w-full sm:w-3/5 rounded-md">
          <form action="">
            <label htmlFor="fullname">Full Name</label>
            <input
              className="w-full p-3 border-2 border-solid border-yellow-300 mt-1 mb-4"
              type="text"
              id="fullname"
              name="fullname"
              placeholder="Your name.."
            />

            <label htmlFor="subject">Subject</label>
            <input
              className="w-full p-3 border-2 border-solid border-yellow-300 mt-1 mb-4"
              type="text"
              id="subject"
              name="subjct"
              placeholder="Subject"
            />

            <label htmlFor="message">Message</label>
            <textarea
              className="w-full p-3 border-2 border-solid border-yellow-300 mt-1 mb-4 resize-y"
              id="message"
              name="message"
              placeholder="Write something.."
              style={{ height: "200px" }}
            ></textarea>

            <div className="flex justify-center items-center sm:block">
              <input
                className="text-yellow-300 border-2 border-yellow-300 cursor-pointer px-4 py-2
               hover:bg-yellow-300 hover:text-gray1"
                type="submit"
                value="Submit"
              />
            </div>
          </form>
        </div> */}

        <div className="w-full flex flex-wrap justify-center items-center my-8">
          <div>
            <h2 className="w-full text-xl text-yellow-300 text-semibold text-center">
              Connect with me here !!
            </h2>
            <div className="flex flex-wrap justify-between items-center">
              <div className="p-5">
                <a
                  href="https://github.com/aniketnegii"
                  target="_blank"
                  rel="noreferrer"
                >
                  <GitHubIcon
                    className="hover:text-yellow-300"
                    fontSize="large"
                  />
                </a>
              </div>
              <div className="p-5">
                <a
                  href="https://www.linkedin.com/in/aniketnegi/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <LinkedInIcon
                    className="hover:text-yellow-300"
                    fontSize="large"
                  />
                </a>
              </div>
              <div className="p-5">
                <a
                  href="https://twitter.com/aniket__negi"
                  target="_blank"
                  rel="noreferrer"
                >
                  <TwitterIcon
                    className="hover:text-yellow-300"
                    fontSize="large"
                  />
                </a>
              </div>
            </div>
          </div>
          {/* <div className="hidden sm:block text-xl w-full text-center">
            {"<--"} or mail me
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default Contact;
